import {
  Button,
  ButtonVariant,
  Modal,
  IconButton,
  IconButtonVariant,
  IconButtonSize,
  ButtonSize
} from "shared/components";

import { DiscountCode } from "views/discounts/types";
import { DiscountCodesDisplayTable } from "./DiscountCodesDisplayTable";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";

interface ActiveDiscountsModalProps {
  isOpen: boolean;
  onClose: () => void;
  discounts: DiscountCode[];
}

export const ActiveDiscountsModal = ({
  isOpen,
  onClose,
  discounts
}: ActiveDiscountsModalProps) => {
  if (!isOpen) return null;

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      panelClassName="max-w-[575px] w-full "
    >
      <div className="p-6">
        <div className="flex justify-between relative mb-1">
          <h2 className="text-base font-bold text-content-1000">
            Active discount codes for property
          </h2>
          <IconButton
            variant={IconButtonVariant.TEXT_BASE}
            size={IconButtonSize.SM}
            onClick={onClose}
            HugeIcon={Cancel01Icon}
          />
        </div>
        <p className="text-sm text-content-400 w-3/4">
          Share discount codes with applicants so they can apply them during
          checkout to reduce their application fee
        </p>
      </div>

      {discounts.length > 0 ? (
        <div className="max-h-[400px] overflow-y-auto">
          <DiscountCodesDisplayTable
            discounts={discounts}
            showConfigureButton={false}
          />
        </div>
      ) : null}

      <div className="p-6 pt-4 flex justify-end border-t border-alpha-40">
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.SM}
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
